import type { ReactNode } from 'react';
import { GeometricLoader } from '@/components/GeometricLoader';

/** Existing checkout-to-portal loading surface shared by every purchase kind. */
export function CheckoutClaimLayout({
  pending,
  title,
  message,
  messageRole = 'status',
  children,
}: {
  pending: boolean;
  title: ReactNode;
  message: ReactNode;
  messageRole?: 'status' | 'alert';
  children?: ReactNode;
}) {
  return (
    <main className="min-h-screen flex items-center justify-center px-15">
      <div className="max-w-form w-full">
        {pending && (
          <div className="mb-25 text-ink">
            <GeometricLoader label="Setting up your account" />
          </div>
        )}
        <div className="type-label-sm text-ink-muted">Patient Portal</div>
        <h1 className="type-display-md mt-10">{title}</h1>
        <p role={messageRole} className="type-body-md text-ink-secondary mt-20">
          {message}
        </p>
        {children}
      </div>
    </main>
  );
}
